<!--  -->
<template>
  <van-popup
    class="popupDraw"
    v-model="show"
    :round="true"
    @click-overlay="close"
  >
    <h2 class="recommendFriend">推荐给朋友</h2>
    <div
      class="share"
      ref="imageWrapper"
      v-show="!imgUrl"
    >
      <div class="share-head">
        <img
          src="https://ark-test-cdn-images.iqihang.com/image/20230411/ce5c3f3566b64df69fe874a85833061e.png"
          alt=""
        />
      </div>
      <section class="section">
        <div class="qihang">
          <ul class="shareText">
            <li>快来抽取</li>
            <li>你的考研运势签</li>
          </ul>
          <img
            class="code"
            src="https://ark-prod-cdn-images.iqihang.com/image/20221227/8b608c4b61604df8a8a50b179e0f1192.jpg"
          />
        </div>
      </section>
    </div>
    <div
      class="share"
      v-show="imgUrl"
    >
      <img
        class="poster"
        :src="imgUrl"
        alt=""
      />
    </div>
    <div
      class="share-btn"
      @click="close"
      v-if="!this.$root.isApp"
    >
      <img
        src="../../../assets/img/learningGuidePage/report-share-btn.png"
        alt=""
      />
      <span>长按/截屏保存图片</span>
      <span>分享好友一起抽取考研运势签</span>
    </div>
  </van-popup>
</template>

<script>
import html2canvas from 'html2canvas';

export default {
  components: {
  },
  data() {
    return {
      urls: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/fondOfLearningDraw/%E7%94%BB%E6%9D%BF%202%402x.png`,
      ],
      show: true,
      qrcode: '',
      imgUrl: null,
    };
  },
  props: {
  },
  computed: {},
  watch: {},
  methods: {
    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题

      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.imgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.imgUrl,
            },
            false,
          );
        }
      });
    },

    close() {
      this.$parent.showShare = false;
    },
  },
  created() {
    setTimeout(() => {
      this.toImage();
    }, 0);
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
  },
};
</script>
<style lang="scss" scoped>
.popupDraw {
  background: none;
  border-radius: 36px !important;
}
.recommendFriend {
  margin-bottom: 20px;
  color: #fff;
  font-weight: 500;
  font-size: 32px;
  line-height: 45px;
  text-align: center;
}
.share {
  position: relative;
  width: 600px;
  height: 680px;
  border-radius: 30px;
  .share-head {
    width: 100%;
    height: 500px;
    > img {
      width: 600px;
      height: 500px;
      border-radius: 30px 30px 0 0;
    }
  }
  .section {
    width: 600px;
    height: 180px;
    background: #f1f6ff;
    border-radius: 0 0 30px 30px;
    .qihang {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 600px;
      height: 180px;
      .shareText {
        width: 250px;
        li {
          color: #333;
          font-weight: 400;
          font-size: 30px;
          line-height: 45px;
        }
      }
      .code {
        width: 140px;
        height: 140px;
      }
    }
  }
  .poster {
    width: 100%;
  }
}
.share-btn {
  text-align: center;
  img {
    display: block;
    width: 98px;
    height: 82px;
    margin: 5px auto 10px auto;
  }
  span {
    display: block;
    color: #fff;
    font-weight: 500;
    font-size: 30px;
    line-height: 45px;
  }
}
</style>
